import { render } from "./App.vue?vue&type=template&id=a3a2d9d2&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a3a2d9d2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Fabiano\\Desktop\\Project\\machadofretesemudancas\\machadofretesemudancas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3a2d9d2"]])

export default __exports__